
// import React, { useState } from 'react';
// // import React, { useState } from 'react';
// import { useNavigate } from "react-router-dom";
// // import mechImage from '../img/aaaservices/TOOL & FIXTURE V1.jpg';
// // import itImage from '../img/aaaservices/PYTHON V1.jpg';
// // import digitalImage from '../img/aaaservices/DIGITAL FACILITY SIMULATIONS V3.jpg';

// import mechImg from '../img/aaaservices/VR.webp';
// import simImg from '../img/aaaservices/slashco-bridle1-2.jpg';
// import itImg from '../img/aaaservices/Java-Full-Stack-1-600x367.jpg';
// import itImg1 from '../img/aaaservices/PY.jpg';
// import itImg2 from '../img/aaaservices/app-development-banner_33099-1720.avif';
// import dfsImg from '../img/aaaservices/F.png';
// import dfsImg1 from '../img/aaaservices/Thumbnail-Skill-Based-Professions-1.png';
// import dfsImg2 from '../img/aaaservices/s.png';
// import dfsImg3 from '../img/aaaservices/d.webp';
// import OnlyButtonrange from './OnlyButtonrange';
// import Advertisment from './Advertisment';

// const cardData = {
//   Mechanical: [
//     { id: 1, title: "Virtual Robotics", subtitle: "Simulated Automation", date: "2025-06-01", time: "10:00 AM - 4:00 PM", cost: "₹150", minPrice: 150, maxPrice: 150, location: "hyderabad", language: "english", image: mechImg, link: "/Virtualpage" },
//     { id: 2, title: "Tool & Fixture Design", subtitle: "3D Product Design", date: "2025-06-05", time: "11:00 AM - 5:00 PM", cost: "₹120", minPrice: 100, maxPrice: 200, location: "bangalore", language: "hindi", image: simImg, link: "/fixture" },
//     { id: 3, title: "Digital Factory", subtitle: "Smart Production", date: "2025-06-10", time: "9:00 AM - 3:00 PM", cost: "₹180", minPrice: 150, maxPrice: 250, location: "chennai", language: "telugu", image: dfsImg, link: "/DigitalC" },
//   ],
//   IT: [
//     { id: 4, title: "Java Full-Stack Developers", subtitle: "Complete Stack", date: "2025-06-17", time: "1:00 PM - 6:00 PM", cost: "₹350", minPrice: 300, maxPrice: 400, location: "hyderabad", language: "english", image: itImg, link: "/it-services" },
//     { id: 5, title: "Python Full-Stack Developers", subtitle: "Complete Stack", date: "2025-06-19", time: "10:00 AM - 2:00 PM", cost: "₹300", minPrice: 250, maxPrice: 350, location: "mumbai", language: "english", image: itImg1, link: "/Puthonpage" },
//     { id: 6, title: "Flutter Developers", subtitle: "Cross-Platform Apps", date: "2025-06-19", time: "10:00 AM - 2:00 PM", cost: "₹300", minPrice: 250, maxPrice: 350, location: "bangalore", language: "tamil", image: itImg2, link: "/Reactpage" },
//   ],
//   Digital: [
//     { id: 7, title: "Career Foundation Skills", subtitle: "Professional Basics", date: "2025-06-21", time: "10:00 AM - 4:00 PM", cost: "₹400", minPrice: 400, maxPrice: 500, location: "chennai", language: "telugu", image: dfsImg1, link: "/Outdoor" },
//     { id: 8, title: "Soft Skill Enhancements", subtitle: "Communication Mastery", date: "2025-06-22", time: "9:00 AM - 1:00 PM", cost: "₹450", minPrice: 400, maxPrice: 500, location: "hyderabad", language: "english", image: dfsImg2, link: "/Sopftskillpage" },
//     { id: 9, title: "Digital Presence Skills", subtitle: "Online Branding", date: "2025-06-22", time: "9:00 AM - 1:00 PM", cost: "₹450", minPrice: 400, maxPrice: 500, location: "mumbai", language: "hindi", image: dfsImg3, link: "/Digitalpresenceskillpage" },
//   ]
// };

// const BranchFilterComponent = () => {
//   const navigate = useNavigate();

//   const [selectedBranch, setSelectedBranch] = useState('All');
//   const [calendarDate, setCalendarDate] = useState('');
//   const [location, setLocation] = useState('');
//   const [language, setLanguage] = useState('');
//   const [minPrice, setMinPrice] = useState('');
//   const [maxPrice, setMaxPrice] = useState('');

//   const getFilteredData = () => {
//     let data = selectedBranch === 'All'
//       ? [...cardData.Mechanical, ...cardData.IT, ...cardData.Digital]
//       : cardData[selectedBranch] || [];

//     if (calendarDate) {
//       data = data.filter(card => card.date === calendarDate);
//     }

//     if (location) {
//       data = data.filter(card => card.location === location);
//     }

//     if (language) {
//       data = data.filter(card => card.language === language);
//     }

//     if (minPrice !== '') {
//       data = data.filter(card => card.minPrice >= parseInt(minPrice));
//     }

//     if (maxPrice !== '') {
//       data = data.filter(card => card.maxPrice <= parseInt(maxPrice));
//     }

//     return data;
//   };

//   return (
//     <div className="filter-container">
//       <div className="sidebar">
//         <h3 style={{fontFamily:'sans-serif',fontSize:'20px',color:'blue',marginTop:'2px'}}>Filters</h3>

//         <select value={selectedBranch} onChange={(e) => setSelectedBranch(e.target.value)}>
//           <option value="All">All Branches</option>
//           <option value="Mechanical">Mechanical</option>
//           <option value="IT">IT</option>
//           <option value="Digital">Jose</option>
//         </select>

//         <input type="date" value={calendarDate} onChange={(e) => setCalendarDate(e.target.value)} />

//         <select value={location} onChange={(e) => setLocation(e.target.value)}>
//           <option value="">Location</option>
//           <option value="hyderabad">Hyderabad</option>
//           <option value="bangalore">Bangalore</option>
//           <option value="chennai">Chennai</option>
//           <option value="mumbai">Mumbai</option>
//         </select>

//         <select value={language} onChange={(e) => setLanguage(e.target.value)}>
//           <option value="">Language</option>
//           <option value="english">English</option>
//           <option value="hindi">Hindi</option>
//           <option value="telugu">Telugu</option>
//           <option value="tamil">Tamil</option>
//         </select>

//         <select value={minPrice} onChange={(e) => setMinPrice(e.target.value)}>
//           <option value="">Min Price</option>
//           <option value="100">100</option>
//           <option value="200">200</option>
//           <option value="300">300</option>
//           <option value="400">400</option>
//         </select>

//         <select value={maxPrice} onChange={(e) => setMaxPrice(e.target.value)}>
//           <option value="">Max Price</option>
//           <option value="300">300</option>
//           <option value="400">400</option>
//           <option value="500">500</option>
//         </select>
//       </div>

//       <div className="card-section">
//         {getFilteredData().map((card) => (
//           <div className="card" key={card.id} onClick={() => navigate(card.link)}>
//             <img src={card.image} alt={card.title} />
//             <div className="card-content">
//               <p style={{ fontSize: '20px', color: 'blue', fontFamily: 'roboto' }}>{card.title}</p>
//               <p>{card.subtitle}</p>
//               <p>{card.date} | {card.time}</p>
//               <p>{card.cost}</p>
//              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//   <p style={{ marginRight: '10px' }}>{card.location}, {card.language}</p>
//   <button style={{ 
//     borderRadius: '10px', 
//     backgroundColor: 'blue', 
//     color: 'white',
//     padding: '5px 15px',
//     border: 'none',
//     cursor: 'pointer'
//   }}>
//     Know More
//   </button>
// </div>

//             </div>
//           </div>
//         ))}
//       </div>

// <Advertisment />
//       <style jsx>{`
//         .filter-container {
//           display: flex;
//           gap: 20px;
//           padding: 20px;
          
//         }

//         .sidebar {
//            min-width: 260px;
//            position: sticky;
//            max-width:320px;
//            top: 172px;
//            background: #f9f9f9;
//           padding: 15px;
//            border-radius: 8px;
//            box-shadow: 0 0 10px rgba(0,0,0,0.1);
//            height: fit-content;
//          }

//         .sidebar select,
//         .sidebar input[type="date"] {
//           width: 100%;
//           padding: 8px;
//           margin-bottom: 15px;
//           font-size: 15px;
//           border-radius: 5px;
//           border: 1px solid #ccc;
//         }

//         .card-section {
//           flex: 1;
//           display: grid;
//           grid-template-columns: repeat(3, 1fr);
//           gap: 20px;
//         }

//         .card {
//           background: #fff;
//           border-radius: 10px;
//           border: 1px solid #ddd;
//           height:347px;
//           color:black;
//           overflow: hidden;
//           cursor: pointer;
//           transition: transform 0.2s ease;
//         }

//         .card:hover {
//           transform: translateY(-5px);
//         }

//         .card img {
//           width: 100%;
//           height: 160px;
//           object-fit: cover;
//           padding: 10px;
//           border-radius: 20px;
//         }

//         .card-content {
//           padding: 10px;
//         }

//         .card-content p {
//           margin: 5px 0;
//           font-family: math;
//           color:black
//         }

//         @media (max-width: 992px) {
//           .card-section {
//             grid-template-columns: repeat(2, 1fr);
//           }
//         }

//         @media (max-width: 600px) {
//           .filter-container {
//             flex-direction: column;
//           }

//           .sidebar {
//              width: 98%;
//              position: relative;
//              top: auto;
//            }


// @media (max-width: 480px) {
//           .filter-container {
//             flex-direction: column;
//           }

//           .sidebar {
//              width: 98%;
//              position: relative;
//              top: auto;
//            }


//              .card{
//              width:98%;
//              }

//           .card-section {
//             grid-template-columns: 1fr;
//           }
//         }
//       `}</style>

//       <div style={{marginTop:'-314px',left:'-2px'}}>
//       <OnlyButtonrange />
//       </div>
    
//     </div>
//   );
// };

// export default BranchFilterComponent;



 


import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import accountingImg from './incomtax.jpg';

import OnlyButtonrange from './OnlyButtonrange';
import Advertisment from './Advertisment';



import payrollImg from './professional-payroll-services.webp';

import payrollimag1 from './selection-116.png'
import payrollimag2 from './gpa.webp'
import taxImg from './GSTPractitionerCourseOnline.jpg';
import taximage1 from './incomtax.jpg'
import taximage2 from './International-Taxation.png'
import auditImg from './international.jpg';
import forinsic from './forensic-audit-service.jpg'
import sapImg from './sap-fico-training-3162023.png';
import tallyImg from '../img/aaaservices/Advanced-Acc.jpg';
import quickbooksImg from './QuickBooks_training.png';

const cardData = {
  Accounting: [
    {
      id: 1,
      title: "Core Accounting Fundamentals",
      subtitle: "Bookkeeping & Financial Statements",
      date: "2025-06-01",
      time: "10:00 AM - 4:00 PM",
      cost: "₹6,000",
      minPrice: 6000,
      maxPrice: 6000,
      duration: "1 Month | 60 Hours",
      location: "hyderabad",
      language: "english",
      image: accountingImg,
      link: "/Carierprogramepage",
      eligibility: "B.Com/M.Com/MBA/Finance",
      mode: "Online/Offline",
      certification: "Yes"
    },
    {
      id: 2,
      title: "Advanced Accounting with Tally",
      subtitle: "Complete Tally Prime Training",
      date: "2025-06-05",
      time: "11:00 AM - 5:00 PM",
      cost: "₹8,000",
      minPrice: 8000,
      maxPrice: 8000,
      duration: "6 Weeks | 80 Hours",
      location: "bangalore",
      language: "hindi",
      image: tallyImg,
       link: "/Carierprogramepage",
      eligibility: "Basic Accounting Knowledge",
      mode: "Online/Offline",
      certification: "Yes"
    },
    {
      id: 3,
      title: "QuickBooks Certification Program",
      subtitle: "US Accounting Software Training",
      date: "2025-06-10",
      time: "9:00 AM - 3:00 PM",
      cost: "₹7,500",
      minPrice: 7500,
      maxPrice: 7500,
      duration: "5 Weeks | 70 Hours",
      location: "chennai",
      language: "english",
      image: quickbooksImg,
      link: "/Carierprogramepage",
      eligibility: "B.Com/M.Com/MBA",
      mode: "Online",
      certification: "Yes"
    }
  ],

  Taxation: [
    {
      id: 4,
      title: "GST Practitioner Course",
      subtitle: "GST Filing & Compliance",
      date: "2025-06-17",
      time: "1:00 PM - 6:00 PM",
      cost: "₹9,000",
      minPrice: 9000,
      maxPrice: 9000,
      duration: "2 Months | 100 Hours",
      location: "hyderabad",
      language: "english",
      image: taxImg,
      link: "/Carierprogramepage",
      eligibility: "B.Com/M.Com/CA Inter",
      mode: "Offline",
      certification: "Yes"
    },
    {
      id: 5,
      title: "Income Tax Specialist Program",
      subtitle: "ITR Filing & Tax Planning",
      date: "2025-06-19",
      time: "10:00 AM - 2:00 PM",
      cost: "₹8,500",
      minPrice: 8500,
      maxPrice: 8500,
      duration: "6 Weeks | 75 Hours",
      location: "mumbai",
      language: "hindi",
      image: taximage1,
      link: "/Carierprogramepage",
      eligibility: "B.Com/M.Com/CA Inter",
      mode: "Hybrid",
      certification: "Yes"
    },
    {
      id: 10,
      title: "International Taxation Course",
      subtitle: "Global Tax Compliance",
      date: "2025-06-23",
      time: "9:00 AM - 1:00 PM",
      cost: "₹12,000",
      minPrice: 12000,
      maxPrice: 12000,
      duration: "2 Months | 90 Hours",
      location: "bangalore",
      language: "english",
      image: taximage2,
      link: "/Carierprogramepage",
      eligibility: "CA/CS/MBA Finance",
      mode: "Online",
      certification: "Yes"
    }
  ],

  Payroll: [
    {
      id: 6,
      title: "Payroll Management Professional",
      subtitle: "Salary Processing & Compliance",
      date: "2025-06-19",
      time: "10:00 AM - 2:00 PM",
      cost: "₹7,000",
      minPrice: 7000,
      maxPrice: 7000,
      duration: "1 Month | 60 Hours",
      location: "bangalore",
      language: "english",
      image: payrollImg,
       link: "/Carierprogramepage",
      eligibility: "Any Graduate",
      mode: "Online",
      certification: "Yes"
    },
    {
      id: 7,
      title: "PF & ESI Compliance Training",
      subtitle: "Statutory Compliance Program",
      date: "2025-06-21",
      time: "10:00 AM - 4:00 PM",
      cost: "₹6,500",
      minPrice: 6500,
      maxPrice: 6500,
      duration: "4 Weeks | 50 Hours",
      location: "chennai",
      language: "english",
      image: payrollimag1,
      link: "/Carierprogramepage",
      eligibility: "B.Com/Any Graduate",
      mode: "Offline",
      certification: "Yes"
    },
    {
      id: 11,
      title: "Global Payroll Certification",
      subtitle: "Multi-country Payroll Processing",
      date: "2025-06-24",
      time: "2:00 PM - 6:00 PM",
      cost: "₹11,000",
      minPrice: 11000,
      maxPrice: 11000,
      duration: "8 Weeks | 100 Hours",
      location: "hyderabad",
      language: "english",
      image: payrollimag2,
      link: "/Carierprogramepage",
      eligibility: "2+ Years Payroll Experience",
      mode: "Hybrid",
      certification: "Yes"
    }
  ],

  Audit: [
    {
      id: 8,
      title: "Internal Audit Certification",
      subtitle: "Risk Management & Controls",
      date: "2025-06-22",
      time: "9:00 AM - 1:00 PM",
      cost: "₹10,000",
      minPrice: 10000,
      maxPrice: 10000,
      duration: "2 Months | 120 Hours",
      location: "hyderabad",
      language: "english",
      image: auditImg,
       link: "/Carierprogramepage",
      eligibility: "B.Com/M.Com/CA Inter",
      mode: "Hybrid",
      certification: "Yes"
    },
    {
      id: 9,
      title: "SAP FICO Training Program",
      subtitle: "ERP Financial Accounting",
      date: "2025-06-22",
      time: "9:00 AM - 1:00 PM",
      cost: "₹15,000",
      minPrice: 15000,
      maxPrice: 15000,
      duration: "3 Months | 180 Hours",
      location: "mumbai",
      language: "english",
      image: sapImg,
       link: "/Carierprogramepage",
      eligibility: "B.Com/M.Com/MBA Finance",
      mode: "Offline",
      certification: "Yes"
    },
    {
      id: 12,
      title: "Forensic Accounting Course",
      subtitle: "Fraud Detection & Investigation",
      date: "2025-06-25",
      time: "10:00 AM - 2:00 PM",
      cost: "₹14,000",
      minPrice: 14000,
      maxPrice: 14000,
      duration: "10 Weeks | 150 Hours",
      location: "delhi",
      language: "english",
      image: forinsic,
       link: "/Carierprogramepage",
      eligibility: "CA/CS/CFA",
      mode: "Online",
      certification: "Yes"
    }
  ]
};


const BranchFilterComponent = () => {
  const navigate = useNavigate();

  const [selectedBranch, setSelectedBranch] = useState('All');
  const [calendarDate, setCalendarDate] = useState('');
  const [location, setLocation] = useState('');
  const [language, setLanguage] = useState('');
  const [minPrice, setMinPrice] = useState('');
  const [maxPrice, setMaxPrice] = useState('');
  const [duration, setDuration] = useState('');
  const [mode, setMode] = useState('');

  const getFilteredData = () => {
    let data = selectedBranch === 'All'
      ? [...cardData.Accounting, ...cardData.Taxation, ...cardData.Payroll, ...cardData.Audit]
      : cardData[selectedBranch] || [];

    if (calendarDate) {
      data = data.filter(card => card.date === calendarDate);
    }

    if (location) {
      data = data.filter(card => card.location === location);
    }

    if (language) {
      data = data.filter(card => card.language === language);
    }

    if (minPrice !== '') {
      data = data.filter(card => card.minPrice >= parseInt(minPrice));
    }

    if (maxPrice !== '') {
      data = data.filter(card => card.maxPrice <= parseInt(maxPrice));
    }

    if (duration) {
      data = data.filter(card => card.duration.includes(duration));
    }

    if (mode) {
      data = data.filter(card => card.mode.toLowerCase().includes(mode.toLowerCase()));
    }

    return data;
  };

  return (
    <div className="filter-container">
      <div className="sidebar">
        <h3 style={{fontFamily:'sans-serif',fontSize:'20px',color:'blue',marginTop:'2px'}}> Career Programs</h3>

        <select value={selectedBranch} onChange={(e) => setSelectedBranch(e.target.value)}>
          <option value="All">All Programs</option>
          <option value="Accounting">Accounting</option>
          <option value="Taxation">Taxation</option>
          <option value="Payroll">Payroll</option>
          <option value="Audit">Audit</option>
        </select>

        <input type="date" value={calendarDate} onChange={(e) => setCalendarDate(e.target.value)} />

        <select value={location} onChange={(e) => setLocation(e.target.value)}>
          <option value="">Location</option>
          <option value="hyderabad">Hyderabad</option>
          <option value="bangalore">Bangalore</option>
          <option value="chennai">Chennai</option>
          <option value="mumbai">Mumbai</option>
        </select>

        <select value={language} onChange={(e) => setLanguage(e.target.value)}>
          <option value="">Language</option>
          <option value="english">English</option>
          <option value="hindi">Hindi</option>
        </select>

        <select value={duration} onChange={(e) => setDuration(e.target.value)}>
          <option value="">Duration</option>
          <option value="1 Month">1 Month</option>
          <option value="6 Weeks">6 Weeks</option>
          <option value="2 Months">2 Months</option>
          <option value="3 Months">3 Months</option>
        </select>

        <select value={mode} onChange={(e) => setMode(e.target.value)}>
          <option value="">Mode</option>
          <option value="Online">Online</option>
          <option value="Offline">Offline</option>
          <option value="Hybrid">Hybrid</option>
        </select>

        <select value={minPrice} onChange={(e) => setMinPrice(e.target.value)}>
          <option value="">Min Price</option>
          <option value="6000">₹6,000</option>
          <option value="8000">₹8,000</option>
          <option value="10000">₹10,000</option>
          <option value="15000">₹15,000</option>
        </select>

        <select value={maxPrice} onChange={(e) => setMaxPrice(e.target.value)}>
          <option value="">Max Price</option>
          <option value="8000">₹8,000</option>
          <option value="10000">₹10,000</option>
          <option value="15000">₹15,000</option>
          <option value="20000">₹20,000</option>
        </select>
      </div>

      <div className="card-section">
        {getFilteredData().map((card) => (
          <div className="card" key={card.id} onClick={() => navigate(card.link)}>
            <img src={card.image} alt={card.title} />
            <div className="card-content">
              <p style={{ fontSize: '20px', color: 'blue', fontFamily: 'roboto' }}>{card.title}</p>
              <p>{card.subtitle}</p>
              <p><strong>Duration:</strong> {card.duration}</p>
              <p><strong>Eligibility:</strong> {card.eligibility}</p>
              <p><strong>Mode:</strong> {card.mode} | <strong>Certification:</strong> {card.certification}</p>
              <p><strong>Starts:</strong> {card.date} | {card.time}</p>
              <p><strong>Fee:</strong> {card.cost}</p>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <p style={{ marginRight: '10px' }}>{card.location}, {card.language}</p>
                <button style={{ 
                  borderRadius: '10px', 
                  backgroundColor: 'blue', 
                  color: 'white',
                  padding: '5px 15px',
                  border: 'none',
                  cursor: 'pointer'
                }}>
                  Enroll Now
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      <Advertisment />
      <style jsx>{`
        .filter-container {
          display: flex;
          gap: 20px;
          padding: 20px;
         
        }

        .sidebar {
          min-width: 260px;
          position: sticky;
          max-width:320px;
          top: 0px;
          background: #f9f9f9;
          padding: 15px;
          border-radius: 8px;
          box-shadow: 0 0 10px rgba(0,0,0,0.1);
          height: fit-content;
        }

        .sidebar select,
        .sidebar input[type="date"] {
          width: 100%;
          padding: 8px;
          margin-bottom: 15px;
          font-size: 15px;
          border-radius: 5px;
          border: 1px solid #ccc;
        }

        .card-section {
          flex: 1;
          display: grid;
         
          grid-template-columns: repeat(3, 1fr);
          gap: 20px;
        }

        .card {
          background: #fff;
          border-radius: 10px;
          border: 1px solid #ddd;
           height:450px;
        //   height: auto;
        //   min-height: 500px;
          color:black;
          overflow: hidden;
          cursor: pointer;
          transition: transform 0.2s ease;
        }

        .card:hover {
          transform: translateY(-5px);
          box-shadow: 0 5px 15px rgba(0,0,0,0.1);
        }

        .card img {
          width: 100%;
          height: 160px;
          object-fit: cover;
          padding: 10px;
          border-radius: 20px;
        }

        .card-content {
          padding: 10px;
        }

        .card-content p {
          margin: 8px 0;
          font-family: math;
          color:black;
          font-size: 14px;
        }

        .card-content strong {
          font-weight: bold;
        }

        @media (max-width: 992px) {
          .card-section {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        @media (max-width: 600px) {
          .filter-container {
            flex-direction: column;
          }

          .sidebar {
            width: 98%;
            position: relative;
            max-width:363px;
            top: auto;
          }

          .card {
            width:98%;
          }

          .card-section {
            grid-template-columns: 1fr;
          }
        }
      `}</style>

      <div style={{marginTop:'-314px',left:'-2px'}}>
        <OnlyButtonrange />
      </div>
    </div>
  );
};

export default BranchFilterComponent;


